module.exports = __webpack_public_path__ + "img/icon-reports-analytics.10c15f79.svg";